module.exports = __webpack_public_path__ + "img/img-publicidad-negocio.c32be7b4.png";